import { render, staticRenderFns } from "./AdminsInfo.vue?vue&type=template&id=68a12510&scoped=true&"
import script from "./AdminsInfo.vue?vue&type=script&lang=ts&"
export * from "./AdminsInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a12510",
  null
  
)

export default component.exports